import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'VIDEO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'VIDEO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('videoForm', registro)
    ];
}

export function getLista() {
	const request = axios.get(`${consts.API_URL}/video`);
	return {
		type: 'VIDEO_LISTADO',
		payload: request
	};
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
			axios.post(`${consts.API_URL}/video`, {
				...registro,
				celular: FormatUtils.removerMascara(registro.celular),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/video`, {
				...registro,
				celular: FormatUtils.removerMascara(registro.celular),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function salvarOrdem(lista) {
    return async (dispatch, getState) => {
		
		for (let i = 0; i < lista.length; i++) {
			const registro = lista[i];

			await axios.put(`${consts.API_URL}/video`, {
				...registro,
				ordem: i + 1,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
			}).catch(e => {
				setErroAPI(e);
			});
		}

		setSuccess('Operação Realizada com sucesso.');
		dispatch(getLista());
		dispatch(setModoTela('lista'));
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/video?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}